import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import Typography from '@material-ui/core/Typography';
import { CardMedia } from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: '0px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundImage: 'url(weather-bg.png)',
    backgroundColor: 'rgba(255, 0, 0, 0.1)',
  },
  title: {
    marginTop: '10px',
    marginBottom: '10px',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  gridList: {
    flexWrap: 'nowrap',
    alignContent: 'center',
  },
  weather__icon: {
    width: 40,
    height: 40,
    top: 0,
    transform: 'translateY(0%)',
    left: 0,
},
day: {
  textAlign: 'center',
  border: '1px solid',
  borderColor: '#c1bbbb',
  minWidth: '185px'
},
info:{
  fontSize: 10,
  fontWeight: "bold",
},
temp:{
  fontSize: 15,
  fontWeight: "bold",
},
date:{
  fontSize: 12,
  fontWeight: "bold",
  color: "#212222"
}
}));

function WeatherWeek({weekData}) {
  const classes = useStyles();
  
  const formatDate = (date) => {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
  }

  const getWeekDay = (date) => {

    const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate()

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return weekday[d.getDay()];
  }

  const isSampleHour = (date) => {

    var d = new Date(date);

    if (d.getHours()===12) {
      return true
    }
    else {
      return false
    }

  }
  
  const DEFAULT_IMAGE="weather-icon-place-holder.webp"

  const imageFallBack = (e) => {
    e.onerror = null; // prevents looping
    e.target.src = DEFAULT_IMAGE;
  }
 
  return (
    <CardMedia className={classes.root}>
        <Typography className={classes.title}>
          Weather Forecast in My Area
          </Typography>
      <GridList className={classes.gridList} cellHeight="auto" spacing={4}>
        {weekData.map((data) => (
          isSampleHour(data.date)) ? (
            <GridListTile key={data._id} cols={0.5} className={classes.day}>
                <Typography className={classes.date} gutterBottom>{getWeekDay(data.date)}<br/>{formatDate(data.date)}</Typography> 
              {/* <img src={data.icon} className={classes.weather__icon} onError={imageFallBack}/> */}
              <Typography gutterBottom className={classes.temp}>
                {data.air_temp}°F
              </Typography>
              <Typography className={classes.info}  gutterBottom>
                {data.short_forecast}
              </Typography>
            </GridListTile>
          ) : (null)
        )}
      </GridList>
    </CardMedia>
  );
}

export default WeatherWeek;